import React, { useState, useEffect } from 'react';

// Services
import { getInventario } from '../../../services/StoreService';
import { registrarCompras} from '../../../services/ComprasService'; // El service que creamos

// Estilos
import '../../static/Global.css';
import '../../static/Home.css';
import '../../static/RegistrarMovimiento.css'; // Usamos tu base de estilos

const RegistrarCompras = () => {
    const [vendedor, setVendedor] = useState({ id: null, nombre: "Cargando..." });
    const [proveedor, setProveedor] = useState(''); // Estado para el proveedor
    const [busqueda, setBusqueda] = useState('');
    const [productosDB, setProductosDB] = useState([]);
    const [carrito, setCarrito] = useState([]);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        // Intentamos buscar en sessionStorage primero, y si no, en localStorage
        const userSession = sessionStorage.getItem('usuario_novatech') || localStorage.getItem('usuario_novatech');
        
        if (userSession) {
            try {
                const user = JSON.parse(userSession);
                setVendedor({
                    id: user.id,
                    nombre: user.nombre
                });
            } catch (e) {
                console.error("Error al recuperar el nombre:", e);
                setVendedor({ id: null, nombre: "Error" });
            }
        } else {
            setVendedor({ id: null, nombre: "Invitado" });
        }
    }, []);

    useEffect(() => {
        const fetchProds = async () => {
            try {
                const data = await getInventario();
                setProductosDB(data);
            } catch (error) {
                console.error("Error cargando inventario:", error);
            }
        };
        fetchProds();
    }, []);

    useEffect(() => {
        const nuevoTotal = carrito.reduce((acc, item) => acc + item.subtotal, 0);
        setTotal(nuevoTotal);
    }, [carrito]);


    const agregarAlCarrito = (prod) => {
    const existe = carrito.find(
        item => item.articulo_id === prod.productos_id
    );

    if (existe) {
        actualizarCantidad(
            prod.productos_id,
            existe.cantidad + 1
        );
    } else {

        const precioCompra = parseFloat(prod.precio_compra || 0);

        const nuevoItem = {
            articulo_id: prod.productos_id,
            nombre: prod.nombre,

            // 👇 AHORA USA PRECIO_COMPRA
            precio_compra: precioCompra,

            cantidad: 1,

            // 👇 subtotal automático
            subtotal: precioCompra
        };

        setCarrito([...carrito, nuevoItem]);
    }
    setBusqueda('');
   };

    const actualizarCantidad = (id, nuevaCant) => {
        if (nuevaCant < 1) return;
        setCarrito(prev => prev.map(item => 
            item.articulo_id === id 
            ? { ...item, cantidad: Number(nuevaCant), subtotal: Number(nuevaCant) * item.precio_compra } 
            : item
        ));
    };

    const quitarProducto = (id) => setCarrito(carrito.filter(item => item.articulo_id !== id));

    const procesarCompra = async () => {
        if (!proveedor.trim()) return alert("Por favor, ingrese el nombre del proveedor.");
        if (carrito.length === 0) return alert("El carrito está vacío.");

        const compraPayload = {
            proveedor: proveedor,
            usuario: vendedor.nombre,
            total: total,
            detalles: carrito.map(item => ({
                articulo_id: item.articulo_id,
                cantidad: item.cantidad,
                precio_compra: item.precio_compra,
                subtotal: item.subtotal
            }))
        };

        try {
            const data = await registrarCompras(compraPayload);
            if (data.success) {
                alert(`✅ Compra #${data.compra_id} registrada con éxito. El stock ha aumentado.`);
                setCarrito([]);
                setProveedor('');
            } else {
                throw new Error(data.error);
            }
        } catch (err) {
            alert(`❌ Error: ${err.message}`);
        }
    };

    const productosFiltrados = busqueda.length > 0 
        ? productosDB.filter(p => p.nombre.toLowerCase().includes(busqueda.toLowerCase()))
        : [];

    return (
        <div className="venta-container">
            <header className="venta-header">
                <h2>Registrar Compra </h2>
                <div className="user-info">
                    Comprador: <strong style={{ color: '#2c3e50' }}>{vendedor.nombre}</strong>
                </div>
            </header>

            <div className="venta-layout">
                <div className="venta-main">
                    {/* SECCIÓN PROVEEDOR */}
                    <div className="proveedor-section">
                        <label>Nombre del Proveedor:</label>
                        <input 
                            type="text" 
                            placeholder="Ej: Hikvision Perú SAC" 
                            value={proveedor}
                            onChange={(e) => setProveedor(e.target.value)}
                            className="input-proveedor"
                        />
                    </div>

                    <div className="search-box">
                        <input 
                            type="text" 
                            placeholder="Buscar producto para comprar..." 
                            value={busqueda}
                            onChange={(e) => setBusqueda(e.target.value)}
                        />
                        {productosFiltrados.length > 0 && (
                            <ul className="search-results">
                                {productosFiltrados.map(p => (
                                    <li key={p.productos_id} onClick={() => agregarAlCarrito(p)}>
                                        <strong>{p.nombre}</strong>
                                        <span className="res-stock">Stock actual: {p.stock}</span>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>

                    <table className="novatech-table">
                        <thead>
                            <tr>
                                <th>Producto</th>
                                <th>Precio Unit. Compra</th>
                                <th style={{ width: '120px' }}>Cantidad</th>
                                <th>Subtotal</th>
                                <th>Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {carrito.map(item => (
                                <tr key={item.articulo_id}>
                                    <td>{item.nombre}</td>
                                    <td>
                                        S/ {item.precio_compra.toFixed(2)}
                                    </td>
                                    <td>
                                        <div className="qty-controls">
                                            <button onClick={() => actualizarCantidad(item.articulo_id, item.cantidad - 1)}>-</button>
                                            <span>{item.cantidad}</span>
                                            <button onClick={() => actualizarCantidad(item.articulo_id, item.cantidad + 1)}>+</button>
                                        </div>
                                    </td>
                                    <td>S/ {item.subtotal.toFixed(2)}</td>
                                    <td>
                                        <button className="btn-remove" onClick={() => quitarProducto(item.articulo_id)}>
                                            <i className="fa fa-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <aside className="venta-summary">
                    <div className="total-card" style={{ backgroundColor: '#28a745' }}>
                        <span className="total-label">TOTAL COMPRA</span>
                        <span className="total-amount">S/ {total.toFixed(2)}</span>
                    </div>
                    <button className="btn-confirm" onClick={procesarCompra} style={{ backgroundColor: '#28a745' }}>
                        <i className="fa fa-save"></i> REGISTRAR COMPRA
                    </button>
                </aside>
            </div>
        </div>
    );
};

export default RegistrarCompras;